// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"4b97089b","236":"136b1ca7","326":"eaef655f","346":"08ec76b6","488":"a1d82bce","683":"7a9ecfd2"}[chunkId] + ".chunk.js";
};